import api from './api';

/**
 * User Management Service
 * Handles CRUD operations for users (Admin only)
 */
export const userService = {
  /**
   * Get all users
   * @returns {Promise<Array>} List of all users
   */
  getAll: async () => {
    const response = await api.get('/users');
    return response.data.users || [];
  },

  /**
   * Get users by role
   * @param {string} role - Role to filter by
   * @returns {Promise<Array>} List of users with specified role
   */
  getByRole: async (role) => {
    const response = await api.get(`/users?role=${role}`);
    return response.data.users || [];
  },

  /**
   * Get user by ID
   * @param {string} userId - User ID
   * @returns {Promise<Object>} User object
   */
  getById: async (userId) => {
    const response = await api.get(`/users/${userId}`);
    return response.data.user;
  },

  /**
   * Create a new user
   * @param {Object} userData - User data (username, email, password, role, manager_id)
   * @returns {Promise<Object>} Created user
   */
  create: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data.user;
  },

  /**
   * Update user
   * @param {string} userId - User ID
   * @param {Object} userData - Updated user data
   * @returns {Promise<Object>} Updated user
   */
  update: async (userId, userData) => {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data.user;
  },

  /**
   * Delete user
   * @param {string} userId - User ID
   * @returns {Promise<Object>} Deletion confirmation
   */
  delete: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  /**
   * Get all SuperUsers (for manager assignment dropdown)
   * @returns {Promise<Array>} List of SuperUsers
   */
  getSuperUsers: async () => {
    const response = await api.get('/users?role=SuperUser');
    return response.data.users || [];
  },

  /**
   * Update user's manager
   * @param {string} userId - User ID
   * @param {string} managerId - Manager's user ID (SuperUser)
   * @returns {Promise<Object>} Updated user
   */
  updateManager: async (userId, managerId) => {
    const response = await api.put(`/users/${userId}/manager`, { manager_id: managerId });
    return response.data.user;
  },
};
